import { LegalEntityUsageDialogProps } from "./LegalEntityTypeUsageDialog.tsx";
import { LegalEntityProcessorTypeUsageViewModel } from "./LegalEntityTypeUsageDialog.types.ts";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export function useLegalEntityTypeUsageDialog(props: LegalEntityUsageDialogProps) {
    const url = `/legalEntity/${props.legalEntityId}/legalEntityTypeUsage?usageTypeId=${props.legalEntityTypeId}`;
    const { isLoading, data } = useDotLegalQuery<LegalEntityProcessorTypeUsageViewModel>(url);

    return { isLoading, data };
}
